<template>
  <div class="progress progress-info progress-striped" :title="currentTitle" @mouseover="updateTitle">
    <div class="bar" :style="{ width: progressPercentage + '%' }"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    totalItems: {
      type: Number,
      required: true,
    },
    completedItems: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      startTime: Date.now(),
      currentTime: Date.now(),
      estimatedEndTime: null,
      currentTitle: '',
    };
  },
  computed: {
    progressPercentage() {
      const percentage = this.completedItems / this.totalItems * 100;
      return Math.max(percentage, 1);
    },
    updateTitle() {
      const remainingTime = this.estimatedEndTime - this.currentTime;
      const seconds = Math.round(remainingTime / 1000);
      const minutes = Math.round(seconds / 60);
      const hours = Math.round(minutes / 60);

      this.currentTitle = `${this.progressPercentage.toFixed(2)}% done. ${this.formatTime(hours, minutes, seconds)}`;
    },
  },

  methods: {
    formatTime(hours, minutes, seconds) {
      if (hours > 1) return `About ${hours} hours remaining.`;
      if (minutes > 1) return `About ${minutes} minutes remaining.`;
      if (seconds <= 10) return 'A few seconds remaining.';
      return `About ${seconds} seconds remaining.`;
    },
    updateEndTime() {
      const elapsedTime = this.currentTime - this.startTime;
      const averageTimePerItem = elapsedTime / this.completedItems;
      const estimatedTotalTime = averageTimePerItem * this.totalItems;
      this.estimatedEndTime = this.startTime + estimatedTotalTime;
    },
  },
  watch: {
    completedItems() {
      this.updateEndTime();
      this.currentTime = Date.now();
    },
  },
  mounted() {
    this.updateEndTime();
    setInterval(() => {
      this.currentTime = Date.now();
    }, 2000);
  },
};
</script>

<style scoped>
.progress {
  min-width: 180px;
  height: 27px;
  z-index: 101;
  float: right;
  margin-left: 4px;
}
</style>
